namespace Module {

    declare const $: any;

    // ===== btn-panelsのナビゲーションボタン（サイト共通share.jsのoffsetTopバグを回避するため独自実装） =====
    // 共通share.jsは a[href^="#"] にバインドされ offsetTop（最も近いposition指定祖先からの相対値）で
    // 着地位置を計算するため、position:relativeなコンテナ配下ではずれてしまう。
    // ここでは href="javascript:void(0);" にして共通ハンドラの対象外にし、
    // getBoundingClientRect + pageYOffsetによる絶対座標で、元のshare.jsと同じjQuery animate(500ms)でスクロールする。
    const naviBtns = document.querySelectorAll<HTMLAnchorElement>('.wg-navi-btn');
    naviBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = btn.dataset.target;
            if (!targetId) return;
            const targetEl = document.getElementById(targetId);
            if (!targetEl) return;
            const top = targetEl.getBoundingClientRect().top + window.pageYOffset;
            $('html, body').stop().animate({ scrollTop: top }, 500);
        });
    });

    const wgplay = document.getElementById('wgplay');
    const playBtn = document.querySelector('.wg-moive-btn');
    const closeBtn = document.querySelector('.wg-close-btn');

    const popmovie = document.getElementById('wgplaymovie');
    const popmovieClose = document.querySelector('.wg-popmovie-close');
    const video = document.getElementById('wg-video') as HTMLVideoElement | null;

    // 動画ポップアップを開く
    function openPopMovie(): void {
        if (!popmovie) return;
        popmovie.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (video) {
            video.currentTime = 0;
            video.play().catch(() => {
                // 自動再生に失敗した場合は何もしない（controlsから手動再生可能）
            });
        }
    }

    // 動画ポップアップを閉じる
    function closePopMovie(): void {
        if (!popmovie) return;
        popmovie.classList.remove('is-open');
        document.body.style.overflow = '';
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    }

    // .wg-moive-btnを押されたら動画ポップアップを表示する
    if (playBtn) {
        playBtn.addEventListener('click', (e) => {
            e.preventDefault();
            openPopMovie();
        });
    }

    // ポップアップ内の閉じるボタンを押されたら閉じる
    if (popmovieClose) {
        popmovieClose.addEventListener('click', (e) => {
            e.preventDefault();
            closePopMovie();
        });
    }

    // 背景（暗幕部分）をクリックしたら閉じる（動画自体のクリックでは閉じない）
    if (popmovie) {
        popmovie.addEventListener('click', (e) => {
            if (e.target === popmovie) {
                closePopMovie();
            }
        });
    }

    // ESCキーで閉じる
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popmovie && popmovie.classList.contains('is-open')) {
            closePopMovie();
        }
    });

    // .wg-close-btnを押されたら#wgplayを非表示にする
    if (closeBtn) {
        closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            if (wgplay) {
                wgplay.style.display = 'none';
            }
        });
    }

    // ===== オープニング（画像プリロード兼用アニメーション） =====
    const opening = document.querySelector('.opening');
    const wondergateMain = document.querySelector('.wondergate');

    // 以下の時間はwondergate_style.scss側のtransition/animation時間と揃えること
    const GATE_ANIM_DURATION = 2400; // .gate-base等のscale transitionの最長値
    const GATE_HOLD_DURATION = 1000; // gate拡大完了後、静止状態を見せておく時間
    const FADE_DURATION = 600; // catch/gateのopacity transition時間
    const LOADING_TIMEOUT = 8000; // 画像読み込みが遅い場合のフォールバック
    const MIN_CATCH_DURATION = 2500; // catchを最低限見せておく時間

    if (opening) {
        const openingEl = opening as HTMLElement;
        const startTime = Date.now();
        let finished = false;
        let imagesReady = false;

        // gateアニメーション完了後、gateをフェードアウトしつつwondergate本編へクロスフェード
        function triggerEnd(): void {
            openingEl.classList.add('is-end');
            if (wondergateMain) {
                wondergateMain.classList.add('is-visible');
            }
            window.setTimeout(() => {
                openingEl.remove();
                document.body.style.overflow = '';
            }, FADE_DURATION);
        }

        // 画像読み込み完了（またはタイムアウト）時にcatch→gateへ切り替える
        function finishLoading(): void {
            if (finished) return;
            finished = true;
            openingEl.classList.add('is-loaded');
            window.setTimeout(triggerEnd, GATE_ANIM_DURATION + GATE_HOLD_DURATION);
        }

        // 画像読み込みが完了していても、catchはMIN_CATCH_DURATION経過するまで表示し続ける
        function tryFinishLoading(): void {
            if (!imagesReady) return;
            const remaining = MIN_CATCH_DURATION - (Date.now() - startTime);
            if (remaining > 0) {
                window.setTimeout(finishLoading, remaining);
            } else {
                finishLoading();
            }
        }

        // オープニング中は背景スクロールをロック
        document.body.style.overflow = 'hidden';

        const images = document.querySelectorAll<HTMLImageElement>('#wrapper img');
        const total = images.length;

        if (total === 0) {
            imagesReady = true;
            tryFinishLoading();
        } else {
            let loadedCount = 0;
            const onImageDone = (): void => {
                loadedCount++;
                if (loadedCount >= total) {
                    imagesReady = true;
                    tryFinishLoading();
                }
            };

            images.forEach((img) => {
                if (img.complete && img.naturalWidth > 0) {
                    onImageDone();
                } else {
                    img.addEventListener('load', onImageDone, { once: true });
                    img.addEventListener('error', onImageDone, { once: true });
                }
            });

            // 読み込みが遅い場合のフォールバック（MIN_CATCH_DURATIONの制約を受けず強制的に進める）
            window.setTimeout(finishLoading, LOADING_TIMEOUT);
        }
    }

}